<template>
  <mdbRow class="mt-3">
    <mdbCol col="12">
      <p v-html="getBenefitTitle()"></p>
    </mdbCol>
    <mdbCol col="12">
      <p v-html="getBenefitText()"></p>
    </mdbCol>
    <mdbCol col="12">
      <p v-html="getRestrictionText()"></p>
    </mdbCol>
    <mdbCol class="text-center" col="12">
      <p style="font-weight:700" v-html="getCodeText()"></p>
    </mdbCol>
    <mdbCol class="text-center" col="12">
      <p v-html="getValidityText()"></p>
    </mdbCol>
    <mdbCol class="text-center" col="12">
      <p v-if="benefit.barcode.length > 0">
      Etuun oikeuttava viivakoodi tulee näkyviin käyttäessäsi edun kassalla.
      </p>
    </mdbCol>
    <mdbCol col="12">
      <mdbRow>
      <mdb-btn class="cs-pink" block size="sm">{{
        getBenefitButtonText()
      }}</mdb-btn>
      </mdbRow>
      <hr />
    </mdbCol>
  </mdbRow>
</template>

<script>
import { mdbRow, mdbCol, mdbBtn } from "mdbvue";

export default {
  name: "CouponPreviewBenefit",
  components: { mdbRow, mdbCol, mdbBtn },
  props: {
    benefit: Object,
  },
  data() {
    return {
    };
  },
  methods: {
    getCodeText() {
      if (this.benefit.code === 1)
        return this.$t("benefit_copy_code") + "003FT4X3";
      if (this.benefit.codegeneric.length > 0)
        return this.$t("benefit_copy_code") + this.benefit.codegeneric;
    },
    getRestrictionText() {
      return this.benefit.restrictions;
    },
    getBenefitTitle() {
      return this.benefit.title;
    },
    getBenefitText() {
      return this.benefit.text;
    },
    getValidityText() {
      var from = new Date(this.benefit.validfrom);
      var to = new Date(this.benefit.validto);
      return (
        this.$t("benefit_validuntil") +
        from.toLocaleDateString("fi-FI") +
        " - " +
        to.toLocaleDateString("fi-FI")
      );
    },
    getBenefitButtonText() {
      if (this.benefit.buttontext.length > 0) {
        return this.benefit.buttontext;
      }
      else if (this.benefit.type == "ONCE") {
        return this.$t("benefit_button_once");
      } else if (this.benefit.type == "ALWAYS") {
        return this.$t("benefit_button_always");
      } else if (this.benefit.type == "WEB") {
        return this.$t("benefit_button_web");
      } else if (this.benefit.type == "TABLERESERVATION") {
        return this.$t("benefit_button_tablereservation");
      }
    },
  },
  mounted() {
    console.log("Mounted CouponPreviewBenefit");
  },
};
</script>

<style scoped>
.btn {
  font-size: 20px;
}
p {
  font-size: 16px;
  font-weight: 400;
  line-height: 20px;
}
</style>
